import { available, unavailable, suggestionStates } from '@/constants/suggestion-statuses'

const ON_THIS_RELAY = unavailable('On this relay', suggestionStates.CURRENT)

/**
 * True for a radio just removed from this relay's form, which is still attached server-side.
 *
 * @param {object} status
 * @param {number|null} currentAssemblyId
 * @returns {boolean}
 */
function isOnCurrentAssembly(status, currentAssemblyId) {
    if (currentAssemblyId === null || currentAssemblyId === undefined) {
        return false
    }

    return status.assembly_id !== undefined && status.assembly_id === currentAssemblyId
}

/**
 * A radio already on the form is "on this relay" regardless of the server,
 * which still reports one added this session (unsaved) as available.
 *
 * @param {object} row a suggestion row
 * @param {{currentAssemblyId?: number|null, selectedUrns?: string[]}} context
 * @returns {{state: string, label: string}}
 */
export default function radioSuggestionStatus(row, { currentAssemblyId = null, selectedUrns = [] } = {}) {
    if (selectedUrns.includes(row?.urn)) {
        return ON_THIS_RELAY
    }

    const status = row?.meta?.status

    if (status?.state === suggestionStates.AVAILABLE) {
        return available
    }

    if (status?.state === suggestionStates.NOT_AVAILABLE) {
        // No label for another relay: the row's details line already names it.
        return isOnCurrentAssembly(status, currentAssemblyId) ? ON_THIS_RELAY : unavailable('')
    }

    // Unknown state (e.g. newer server): treat as unusable rather than assume it's free.
    return unavailable('Availability could not be determined')
}
